export default __webpack_public_path__ + "static/media/SNP.1edc9497.png";